export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CurrencyScalar: any;
  LocalDate: any;
  Long: any;
  Percent: any;
  ZonedDateTime: any;
};

export type Affiliate = {
  __typename?: 'Affiliate';
  campaignReport?: Maybe<AffiliatePartnerCampaignReportPage>;
  campaigns?: Maybe<AffiliateCampaignsPage>;
  commonReport?: Maybe<AffiliatePartnerCommonReportPage>;
  dealTypeReport?: Maybe<AffiliatePartnerDealTypeReportPage>;
  preRegistrations?: Maybe<AffiliatePreRegistrationPage>;
  userReport?: Maybe<AffiliatePartnerUserReportPage>;
};


export type AffiliateCampaignReportArgs = {
  pageRequest?: InputMaybe<PageRequestV2>;
  request?: InputMaybe<AffiliatePartnerCampaignReportRequest>;
};


export type AffiliateCampaignsArgs = {
  pageRequest?: InputMaybe<PageRequestV2>;
};


export type AffiliateCommonReportArgs = {
  pageRequest?: InputMaybe<PageRequestV2>;
  request?: InputMaybe<AffiliatePartnerCommonReportRequest>;
};


export type AffiliateDealTypeReportArgs = {
  pageRequest?: InputMaybe<PageRequestV2>;
  request?: InputMaybe<AffiliatePartnerDealTypeReportRequest>;
};


export type AffiliatePreRegistrationsArgs = {
  pageRequest?: InputMaybe<PageRequestV2>;
};


export type AffiliateUserReportArgs = {
  pageRequest?: InputMaybe<PageRequestV2>;
  request?: InputMaybe<AffiliatePartnerUserReportRequest>;
};

export type AffiliateCampaign = {
  __typename?: 'AffiliateCampaign';
  description: Scalars['String'];
  id: Scalars['ID'];
  promoCode?: Maybe<Scalars['String']>;
};

export type AffiliateCampaignsPage = PagedResponseV2 & {
  __typename?: 'AffiliateCampaignsPage';
  content: Array<AffiliateCampaign>;
  pageInfo: PageInfoV2;
};

export type AffiliateDealType = {
  __typename?: 'AffiliateDealType';
  description: Scalars['String'];
  id: Scalars['ID'];
  typeId: Scalars['String'];
};

export type AffiliatePartnerCampaignReportItem = {
  __typename?: 'AffiliatePartnerCampaignReportItem';
  campaign: AffiliateCampaign;
  dealCount: Scalars['Long'];
  dealSum: MoneyV2;
  hitCount: Scalars['Long'];
  registrationCount: Scalars['Long'];
  rewardSum: MoneyV2;
  uniqueVisitCount: Scalars['Long'];
  visitCount: Scalars['Long'];
};

export type AffiliatePartnerCampaignReportPage = PagedResponseV2 & {
  __typename?: 'AffiliatePartnerCampaignReportPage';
  content: Array<AffiliatePartnerCampaignReportItem>;
  dealCount: Scalars['Long'];
  dealSum: MoneyV2;
  hitCount: Scalars['Long'];
  pageInfo: PageInfoV2;
  registrationCount: Scalars['Long'];
  rewardSum: MoneyV2;
  uniqueVisitCount: Scalars['Long'];
  /** Считаются только визиты с явно указанной кампанией */
  visitCount: Scalars['Long'];
};

export type AffiliatePartnerCampaignReportRequest = {
  campaignId?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['CurrencyScalar']>;
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type AffiliatePartnerCommonReportItem = {
  __typename?: 'AffiliatePartnerCommonReportItem';
  date: Scalars['LocalDate'];
  dealCount: Scalars['Long'];
  dealSum: MoneyV2;
  hitCount: Scalars['Long'];
  registrationCount: Scalars['Long'];
  rewardSum: MoneyV2;
  uniqueVisitCount: Scalars['Long'];
  visitCount: Scalars['Long'];
};

export type AffiliatePartnerCommonReportPage = PagedResponseV2 & {
  __typename?: 'AffiliatePartnerCommonReportPage';
  content: Array<AffiliatePartnerCommonReportItem>;
  dealCount: Scalars['Long'];
  dealSum: MoneyV2;
  hitCount: Scalars['Long'];
  pageInfo: PageInfoV2;
  registrationCount: Scalars['Long'];
  rewardSum: MoneyV2;
  uniqueVisitCount: Scalars['Long'];
  visitCount: Scalars['Long'];
};

export type AffiliatePartnerCommonReportRequest = {
  currency?: InputMaybe<Scalars['CurrencyScalar']>;
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type AffiliatePartnerDealTypeReportItem = {
  __typename?: 'AffiliatePartnerDealTypeReportItem';
  dealSum: MoneyV2;
  dealType: AffiliateDealType;
  payoutType: AffiliatePayoutType;
  rewardRate: Scalars['Float'];
  rewardSum: MoneyV2;
};

export type AffiliatePartnerDealTypeReportPage = PagedResponseV2 & {
  __typename?: 'AffiliatePartnerDealTypeReportPage';
  content: Array<AffiliatePartnerDealTypeReportItem>;
  dealCount: Scalars['Long'];
  dealSum: MoneyV2;
  pageInfo: PageInfoV2;
  rewardSum: MoneyV2;
};

export type AffiliatePartnerDealTypeReportRequest = {
  currency?: InputMaybe<Scalars['CurrencyScalar']>;
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type AffiliatePartnerUserReportItem = {
  __typename?: 'AffiliatePartnerUserReportItem';
  dealCount: Scalars['Long'];
  dealSum: MoneyV2;
  rewardSum: MoneyV2;
  user: AffiliateUser;
  withDeals: Scalars['Boolean'];
};

export type AffiliatePartnerUserReportPage = PagedResponseV2 & {
  __typename?: 'AffiliatePartnerUserReportPage';
  content: Array<AffiliatePartnerUserReportItem>;
  dealCount: Scalars['Long'];
  dealSum: MoneyV2;
  pageInfo: PageInfoV2;
  rewardSum: MoneyV2;
};

export type AffiliatePartnerUserReportRequest = {
  currency?: InputMaybe<Scalars['CurrencyScalar']>;
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
  /** search by login substring */
  userLogin?: InputMaybe<Scalars['String']>;
  withDeals?: InputMaybe<Scalars['Boolean']>;
};

export enum AffiliatePayoutType {
  Fix = 'FIX',
  Percent = 'PERCENT'
}

export type AffiliatePreRegistration = {
  __typename?: 'AffiliatePreRegistration';
  campaign: AffiliateCampaign;
  email: Scalars['String'];
  state: AffiliatePreRegistrationState;
};

export type AffiliatePreRegistrationPage = PagedResponseV2 & {
  __typename?: 'AffiliatePreRegistrationPage';
  content: Array<AffiliatePreRegistration>;
  pageInfo: PageInfoV2;
};

export enum AffiliatePreRegistrationState {
  My = 'My',
  NotMy = 'NotMy',
  Potential = 'Potential'
}

/** for security reason we don't use UD.User */
export type AffiliateUser = {
  __typename?: 'AffiliateUser';
  id: Scalars['String'];
  login: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  description: Scalars['String'];
  fractionDigits: Scalars['Int'];
  site: Scalars['String'];
  tags: Array<Scalars['String']>;
};

/** The type assumes expansion with other services, for example in billing - CurrentUser.balance */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  dizraptorUserEntity?: Maybe<DizraptorUserEntity>;
  id: Scalars['String'];
  otpType?: Maybe<UserOtpType>;
  userInfo?: Maybe<UserInfo>;
};

export type Dizraptor = {
  __typename?: 'Dizraptor';
  app: DizraptorApp;
  companies: DizraptorCompanies;
  currentUser?: Maybe<CurrentUser>;
  feed: DizraptorFeed;
  howItWorks: DizraptorHowItWorks;
  ideas: DizraptorIdeas;
  portfolio?: Maybe<DizraptorPortfolio>;
};

export type DizraptorApp = {
  __typename?: 'DizraptorApp';
  /** @deprecated use grpc */
  currentVersion: DizraptorAppVersion;
};


export type DizraptorAppCurrentVersionArgs = {
  request: DizraptorAppPlatform;
};

export enum DizraptorAppPlatform {
  Ios = 'IOS'
}

export type DizraptorAppVersion = {
  __typename?: 'DizraptorAppVersion';
  semverVersion: Scalars['String'];
  updateUrl: Scalars['String'];
};

export type DizraptorCompanies = {
  __typename?: 'DizraptorCompanies';
  company?: Maybe<DizraptorCompany>;
  published: DizraptorCompanyPage;
};


export type DizraptorCompaniesCompanyArgs = {
  id: Scalars['ID'];
};


export type DizraptorCompaniesPublishedArgs = {
  request: DizraptorCompaniesPublishedRequest;
};

export type DizraptorCompaniesPagination = {
  /** if null - default 0 */
  pageNumber?: InputMaybe<Scalars['Long']>;
  /** if null - default 20 */
  pageSize?: InputMaybe<Scalars['Long']>;
};

export type DizraptorCompaniesPublishedRequest = {
  /** null means default pagination (0 index, 20 size) */
  pagination?: InputMaybe<DizraptorCompaniesPagination>;
  status: DizraptorCompanyStatus;
};

export type DizraptorCompany = {
  __typename?: 'DizraptorCompany';
  accentBG: Scalars['String'];
  accentFG: Scalars['String'];
  backgroundColor: Scalars['String'];
  bgImageDesktopUrl?: Maybe<Scalars['String']>;
  /** Background image for the card and pop-up */
  bgImageUrl: Scalars['String'];
  /** Must be not null for 'Exits' status yet allowed in other statuses. */
  exitDate?: Maybe<Scalars['ZonedDateTime']>;
  /** Must be not null for 'Portfolio' status only. Available in 'Underreview' status. Prohibited in other statuses. */
  firstOfferDate?: Maybe<Scalars['ZonedDateTime']>;
  foregroundColor: Scalars['String'];
  /** Markdown */
  fullDescription: Scalars['String'];
  heroDesktopUrl?: Maybe<Scalars['String']>;
  /** Image used as "hero", not the same as logoUrl */
  heroUrl: Scalars['String'];
  id: Scalars['ID'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  /** Must be not null for 'Exits' status only. Prohibited in other statuses. */
  pnlPercent?: Maybe<Scalars['Percent']>;
  /** in plain text format */
  shortDescription: Scalars['String'];
  status: DizraptorCompanyStatus;
  video?: Maybe<DizraptorVideo>;
};

export type DizraptorCompanyPage = DizraptorPagedResponseV2 & {
  __typename?: 'DizraptorCompanyPage';
  content: Array<DizraptorCompany>;
  pageInfo: DizraptorPageInfoV2;
};

export enum DizraptorCompanyStatus {
  Exits = 'Exits',
  Portfolio = 'Portfolio',
  Underreview = 'Underreview'
}

export type DizraptorCompliance = {
  __typename?: 'DizraptorCompliance';
  kyc: DizraptorComplianceKyc;
  /** Current user self-certification info */
  mySelfCertificationInfo?: Maybe<DizraptorComplianceSelfCertificationInfo>;
};

export type DizraptorComplianceKyc = {
  __typename?: 'DizraptorComplianceKyc';
  kycLevel?: Maybe<DizraptorUserKycStates>;
};

export type DizraptorComplianceSelfCertificationInfo = {
  __typename?: 'DizraptorComplianceSelfCertificationInfo';
  /** Чекбокс, что клиент получил пущ-информацию о том, что им был пройден процесс self certification */
  congratulationsWasShown: Scalars['Boolean'];
  id: Scalars['ID'];
  /**
   * Investor's self-certification investorStatus:
   *  - MILLIONAIRE,
   *  - HUNDREDS_OF_THOUSANDS,
   *  - GOOD_STANDING,
   *  - KNOWLEDGEABLE_EMPLOYEE
   */
  investorStatus?: Maybe<Scalars['String']>;
  /** Чекбокс, что клиент подтверждает, что раскрыл все данные для подсчета его net worth */
  isAllDataForCalculatingNetIncomeShowedUp: Scalars['Boolean'];
  /** Чекбокс, что клиент подтверждает, что он единственный инвестор и что все доки относятся строго к нему и не включают доход супруги и пр. */
  isSoloInvestorWithDocumentsRelatedOnlyForHim: Scalars['Boolean'];
  rejectReason?: Maybe<Scalars['String']>;
  status: DizraptorComplianceSelfCertificationStatus;
};

/**
 * Example of self-certification workflow:
 *    digraph G {
 *        CREATED -> IN_REVIEW;
 *        IN_REVIEW -> ACCEPTED;
 *        IN_REVIEW -> REJECTED; // for annoyed spammer
 *        IN_REVIEW -> NEED_FIX;
 *        NEED_FIX -> CREATED;
 *    }
 */
export enum DizraptorComplianceSelfCertificationStatus {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  InReview = 'IN_REVIEW',
  NeedFix = 'NEED_FIX',
  Rejected = 'REJECTED'
}

export enum DizraptorEntityType {
  CCorporation = 'CCorporation',
  ForeignEntity = 'ForeignEntity',
  GeneralPartnership = 'GeneralPartnership',
  LimitedLiabilityCompany = 'LimitedLiabilityCompany',
  LimitedPartnership = 'LimitedPartnership',
  SCorporation = 'SCorporation'
}

export enum DizraptorEnvironment {
  /** Local development environment */
  Dev = 'Dev',
  /** Prod environment (e.g. dizraptor.app) */
  Prod = 'Prod',
  /** Test environment (e.g. dizraptor.work) */
  Test = 'Test'
}

export type DizraptorFeed = {
  __typename?: 'DizraptorFeed';
  post?: Maybe<DizraptorFeedPost>;
  posts: DizraptorFeedPostPage;
};


export type DizraptorFeedPostArgs = {
  id: Scalars['ID'];
};


export type DizraptorFeedPostsArgs = {
  request?: InputMaybe<DizraptorFeedPostsRequest>;
};

export type DizraptorFeedPagination = {
  /** ID of a last seen post. Not null value hides deprecated 'pageNumber' */
  lastSeenId?: InputMaybe<Scalars['ID']>;
  /**
   * @Deprecated
   * If null - default 0
   */
  pageNumber?: InputMaybe<Scalars['Long']>;
  /** if null - default 20 */
  pageSize?: InputMaybe<Scalars['Long']>;
};

export type DizraptorFeedPost = {
  __typename?: 'DizraptorFeedPost';
  backgroundColor: Scalars['String'];
  date: Scalars['ZonedDateTime'];
  foregroundColor: Scalars['String'];
  hasText: Scalars['Boolean'];
  id: Scalars['ID'];
  image?: Maybe<DizraptorFeedPoster>;
  /** Markdown */
  leadParagraph: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  section: DizraptorFeedPostSection;
  /** Markdown. Full post text. Can be null if hasText == false */
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DizraptorFeedPostPage = DizraptorPagedResponseV2 & {
  __typename?: 'DizraptorFeedPostPage';
  canLoadMore: Scalars['Boolean'];
  content: Array<DizraptorFeedPost>;
  /**
   * @Deprecated
   * Use 'canLoadMore'
   */
  pageInfo: DizraptorPageInfoV2;
};

export enum DizraptorFeedPostSection {
  CompaniesNews = 'CompaniesNews',
  Disruptors = 'Disruptors',
  NewIdeas = 'NewIdeas',
  Other = 'Other',
  PlatformNews = 'PlatformNews',
  PriceChanges = 'PriceChanges'
}

export type DizraptorFeedPoster = {
  __typename?: 'DizraptorFeedPoster';
  height: Scalars['Long'];
  url: Scalars['String'];
  width: Scalars['Long'];
};

export type DizraptorFeedPostsRequest = {
  /** null means default pagination (0 index, 20 size) */
  pagination?: InputMaybe<DizraptorFeedPagination>;
  /** null means 'all sections' */
  section?: InputMaybe<DizraptorFeedPostSection>;
};

export type DizraptorHowItWorks = {
  __typename?: 'DizraptorHowItWorks';
  post?: Maybe<DizraptorHowItWorksPost>;
  posts: Array<DizraptorHowItWorksPost>;
};


export type DizraptorHowItWorksPostArgs = {
  id: Scalars['ID'];
};

export type DizraptorHowItWorksPost = {
  __typename?: 'DizraptorHowItWorksPost';
  durationMinutes: Scalars['Int'];
  id: Scalars['ID'];
  image: DizraptorHowItWorksPoster;
  imageDesktop: DizraptorHowItWorksPoster;
  section: DizraptorHowItWorksPostSection;
  shortTitle: Scalars['String'];
  sortIndex: Scalars['Float'];
  /** Markdown */
  text: Scalars['String'];
  title: Scalars['String'];
  video?: Maybe<DizraptorVideo>;
};

export enum DizraptorHowItWorksPostSection {
  Advanced = 'Advanced',
  Main = 'Main'
}

export type DizraptorHowItWorksPoster = {
  __typename?: 'DizraptorHowItWorksPoster';
  height: Scalars['Long'];
  url: Scalars['String'];
  width: Scalars['Long'];
};

export type DizraptorIdea = {
  __typename?: 'DizraptorIdea';
  accentBG: Scalars['String'];
  accentFG: Scalars['String'];
  /** Deadline to enter the idea */
  applyUntil: Scalars['ZonedDateTime'];
  backgroundColor: Scalars['String'];
  bankDetails: DizraptorIdeaBankDetails;
  bgImageDesktopUrl?: Maybe<Scalars['String']>;
  /** Background image for the card and pop-up */
  bgImageUrl: Scalars['String'];
  currentValuation?: Maybe<MoneyV2>;
  foregroundColor: Scalars['String'];
  /** Markdown */
  fullDescription: Scalars['String'];
  heroDesktopUrl?: Maybe<Scalars['String']>;
  /** Image used as "hero", not the same as logoUrl */
  heroUrl: Scalars['String'];
  hintPaidText: Scalars['String'];
  hintUnpaidText: Scalars['String'];
  id: Scalars['ID'];
  investmentAvailability: DizraptorIdeaInvestmentAvailability;
  isPublished: Scalars['Boolean'];
  lastCall?: Maybe<Scalars['Boolean']>;
  lastRoundDate?: Maybe<Scalars['ZonedDateTime']>;
  lastRoundName?: Maybe<Scalars['String']>;
  lastRoundValuation?: Maybe<MoneyV2>;
  logoUrl: Scalars['String'];
  /** Minimum amount to buy */
  minAmount: MoneyV2;
  name: Scalars['String'];
  /** The frontend must use it in the page's title bar, but not in user cards */
  nameSeo: Scalars['String'];
  /** History of price (ASC sorted from the oldest price to the newest price) */
  prices: Array<DizraptorIdeaPrice>;
  /** Idea short description in plain text format */
  shortDescription: Scalars['String'];
  /** DateTime used to sort the idea in the list (newer ideas are higher ranked) */
  sortDate: Scalars['ZonedDateTime'];
  /** Text hints */
  subheaderText: Scalars['String'];
  video?: Maybe<DizraptorVideo>;
};

export type DizraptorIdeaBankDetails = {
  __typename?: 'DizraptorIdeaBankDetails';
  accountNumber?: Maybe<Scalars['String']>;
  addressHint?: Maybe<Scalars['String']>;
  bankAddress?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  bankRouting?: Maybe<Scalars['String']>;
  beneficiaryAddress?: Maybe<Scalars['String']>;
  beneficiaryName?: Maybe<Scalars['String']>;
  purposeOfPayment?: Maybe<Scalars['String']>;
  swift?: Maybe<Scalars['String']>;
};

export enum DizraptorIdeaInvestmentAvailability {
  Available = 'Available',
  UnavailableSinceNotLoggedIn = 'UnavailableSinceNotLoggedIn',
  UnavailableSinceNotPublished = 'UnavailableSinceNotPublished',
  UnavailableSinceUserCardExists = 'UnavailableSinceUserCardExists'
}

export type DizraptorIdeaPrice = {
  __typename?: 'DizraptorIdeaPrice';
  date: Scalars['ZonedDateTime'];
  price: MoneyV2;
};

export type DizraptorIdeas = {
  __typename?: 'DizraptorIdeas';
  all: Array<DizraptorIdea>;
  allPublished: Array<DizraptorIdea>;
  idea?: Maybe<DizraptorIdea>;
};


export type DizraptorIdeasIdeaArgs = {
  id: Scalars['ID'];
};

export enum DizraptorKycLevel {
  Level_0Newbie = 'LEVEL_0_NEWBIE',
  Level_1Validated = 'LEVEL_1_VALIDATED',
  Level_2SelfCertificated = 'LEVEL_2_SELF_CERTIFICATED'
}

export enum DizraptorKycState {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  FinalFailed = 'FINAL_FAILED',
  NotRequested = 'NOT_REQUESTED',
  Requested = 'REQUESTED'
}

export type DizraptorMobileRegistrationCollector = {
  __typename?: 'DizraptorMobileRegistrationCollector';
  isMobileLogged?: Maybe<Scalars['Boolean']>;
};

export type DizraptorPageInfoV2 = {
  __typename?: 'DizraptorPageInfoV2';
  number: Scalars['Long'];
  size: Scalars['Long'];
  totalElements: Scalars['Long'];
  totalPages: Scalars['Long'];
};

export type DizraptorPagedResponseV2 = {
  pageInfo: DizraptorPageInfoV2;
};

export type DizraptorPortfolio = {
  __typename?: 'DizraptorPortfolio';
  summary: DizraptorSummary;
  userCardV2?: Maybe<DizraptorUserCard>;
  userCardsV2: Array<DizraptorUserCard>;
};


export type DizraptorPortfolioUserCardV2Args = {
  id: Scalars['ID'];
};


export type DizraptorPortfolioUserCardsV2Args = {
  request: DizraptorPortfolioUserCardsV2Request;
};

export type DizraptorPortfolioUserCardsV2Request = {
  isArchived?: InputMaybe<Scalars['Boolean']>;
};

export type DizraptorSummary = {
  __typename?: 'DizraptorSummary';
  gains: MoneyV2;
  gainsPercent: Scalars['Percent'];
  invested: MoneyV2;
  total: MoneyV2;
};

/**
 * Each buy creates new user card. Rejection for user card is forever
 *
 * Workflow:
 *
 * digraph G {
 *
 * DizraptorUserCardOrderOpen -> DizraptorUserCardOrderKycRequired
 *
 * // Deprecated
 * DizraptorUserCardOrderKycRequired -> DizraptorUserCardBuyOrderAmountRequired // в случае если у ордера на покупку была 0я сумма (не указана)
 * DizraptorUserCardOrderKycRequired -> DizraptorUserCardOrderAgreementRequired // в случае если у ордера на покупку была указана ранее сумма
 * DizraptorUserCardOrderKycRequired -> DizraptorUserCardRejected [label = "AdminUserCardService.rejectUserCard"]
 *
 * DizraptorUserCardBuyOrderAmountRequired -> DizraptorUserCardOrderAgreementRequired
 *
 * DizraptorUserCardOrderAgreementRequired -> DizraptorUserCardOrderFundsNotReady // если у идеи еще нет реквизитов
 * DizraptorUserCardOrderAgreementRequired -> DizraptorUserCardOrderFundsRequired
 * DizraptorUserCardOrderAgreementRequired -> DizraptorUserCardRejected [label = "AdminUserCardService.rejectUserCard"]
 *
 * DizraptorUserCardOrderFundsNotReady -> DizraptorUserCardOrderFundsRequired [label = TransitionNotPossible]
 * DizraptorUserCardOrderFundsNotReady -> DizraptorUserCardOrderAgreementRequired [label = TransitionNotPossible]
 * DizraptorUserCardOrderFundsNotReady -> DizraptorUserCardRejected [label = TransitionNotPossible]
 *
 * DizraptorUserCardOrderFundsRequired -> DizraptorUserCardOrderFundsReceived [label = "AdminUserCardService.depositUserCard"]
 * DizraptorUserCardOrderFundsRequired -> DizraptorUserCardOrderAgreementRequired // если пользователь решил поменять сумму ордера
 * DizraptorUserCardOrderFundsRequired -> DizraptorUserCardRejected [label = "AdminUserCardService.rejectUserCard"]
 *
 * DizraptorUserCardOrderFundsReceived -> DizraptorUserCardPositionOpen
 * DizraptorUserCardOrderFundsReceived -> DizraptorUserCardOrderAgreementRequired // если пользователь перевел сумму отличную от суммы ордера
 * DizraptorUserCardOrderFundsReceived -> DizraptorUserCardRejected [label = "AdminUserCardService.rejectUserCard"]
 *
 * DizraptorUserCardPositionOpen -> DizraptorUserCardPositionClosed
 * }
 */
export type DizraptorUserCard = {
  canChangeOrderAmount: Scalars['Boolean'];
  /** DateTime when the card was created */
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  id: Scalars['ID'];
  idea: DizraptorIdea;
  orderAmount: MoneyV2;
  /** Amount of shares for deposit */
  positionQty: Scalars['Float'];
  /** Current price of the deposit */
  positionValue: MoneyV2;
  /** DateTime used to sort the card in the list (newer cards are higher ranked) */
  sortDate: Scalars['ZonedDateTime'];
};

/** Admin accepted KYC and requested to sign the Agreement, so an agreement link had been provided */
export type DizraptorUserCardBuyOrderAmountRequired = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardBuyOrderAmountRequired';
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

/** Admin accepted KYC and requested to sign the Agreement, so an agreement link had been provided */
export type DizraptorUserCardOrderAgreementRequired = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardOrderAgreementRequired';
  /**
   * @Deprecated
   * Remove when all clients use DocuSign.
   */
  agreementLink: Scalars['String'];
  alreadyDepositedAmount: MoneyV2;
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  /**
   * @Deprecated
   * Remove when all clients are updated to 3.5.122 and higher
   */
  kycLink: Scalars['String'];
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  requiredDepositAmount: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

/**
 * Admin accepted KYC + Agreement but not provided funds link yet
 * @Deprecated: we use idea.bankDetails, so this status not available anymore
 */
export type DizraptorUserCardOrderFundsNotReady = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardOrderFundsNotReady';
  /**
   * @Deprecated
   * Remove when all clients use DocuSign.
   * May be null when admin accepts Agreement without passing an agreement link
   */
  agreementLink?: Maybe<Scalars['String']>;
  alreadyDepositedAmount: MoneyV2;
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  /**
   * @Deprecated
   * Remove when all clients are updated to 3.5.122 and higher
   */
  kycLink?: Maybe<Scalars['String']>;
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  requiredDepositAmount: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

/** Admin accepted all KYC + Agreement + Funds. Now the deal is closing, we're waiting for a position opening */
export type DizraptorUserCardOrderFundsReceived = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardOrderFundsReceived';
  /**
   * @Deprecated
   * Remove when all clients use DocuSign.
   * May be null when admin accepts Agreement without passing an agreement link
   */
  agreementLink?: Maybe<Scalars['String']>;
  alreadyDepositedAmount: MoneyV2;
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** May be null when admin accepts Funds without passing a funds link */
  fundsLink?: Maybe<Scalars['String']>;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  /**
   * @Deprecated
   * Remove when all clients are updated to 3.5.122 and higher
   */
  kycLink?: Maybe<Scalars['String']>;
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  requiredDepositAmount: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

/** Admin accepted KYC + Agreement and requested to Fund, so a fund link had been provided */
export type DizraptorUserCardOrderFundsRequired = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardOrderFundsRequired';
  /**
   * @Deprecated
   * Remove when all clients use DocuSign.
   * May be null when admin accepts Agreement without passing an agreement link
   */
  agreementLink?: Maybe<Scalars['String']>;
  alreadyDepositedAmount: MoneyV2;
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  fundsLink: Scalars['String'];
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  /**
   * @Deprecated
   * Remove when all clients are updated to 3.5.122 and higher
   */
  kycLink?: Maybe<Scalars['String']>;
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  requiredDepositAmount: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

/**
 * @Deprecated
 * Admin requested to pass KYC, so a KYC link had been provided
 */
export type DizraptorUserCardOrderKycRequired = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardOrderKycRequired';
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  /**
   * @Deprecated
   * Remove when all clients are updated to 3.5.122 and higher
   */
  kycLink: Scalars['String'];
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

export type DizraptorUserCardOrderOpen = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardOrderOpen';
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

export type DizraptorUserCardPositionClosed = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardPositionClosed';
  actualPnl: MoneyV2;
  actualPnlPercent: Scalars['Percent'];
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  isArchived: Scalars['Boolean'];
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
  /** DizraptorUserCard implementation end */
  withdrawAmount: MoneyV2;
};

export type DizraptorUserCardPositionOpen = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardPositionOpen';
  /** DizraptorUserCard implementation end */
  actualPnl: MoneyV2;
  actualPnlPercent: Scalars['Percent'];
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  sortDate: Scalars['ZonedDateTime'];
};

export type DizraptorUserCardRejected = DizraptorUserCard & {
  __typename?: 'DizraptorUserCardRejected';
  canChangeOrderAmount: Scalars['Boolean'];
  creationDate: Scalars['ZonedDateTime'];
  /** @deprecated use orderAmount, alreadyDepositedAmount, requiredDepositAmount fields */
  depositAmount: MoneyV2;
  /** DizraptorUserCard implementation begin */
  id: Scalars['ID'];
  idea: DizraptorIdea;
  isArchived: Scalars['Boolean'];
  orderAmount: MoneyV2;
  positionQty: Scalars['Float'];
  positionValue: MoneyV2;
  /** DizraptorUserCard implementation end */
  rejectDate: Scalars['ZonedDateTime'];
  rejectReason: Scalars['String'];
  sortDate: Scalars['ZonedDateTime'];
};

export type DizraptorUserEntity = {
  __typename?: 'DizraptorUserEntity';
  entityType: DizraptorEntityType;
  fullLegalName: Scalars['String'];
};

export type DizraptorUserKycStates = {
  __typename?: 'DizraptorUserKycStates';
  level0Newbie: DizraptorKycState;
  level1Validated: DizraptorKycState;
  level2SelfCertificated: DizraptorKycState;
};

export type DizraptorVideo = {
  __typename?: 'DizraptorVideo';
  /** Video description in plain text format */
  description?: Maybe<Scalars['String']>;
  /** Url to video file (fallback for devices that cannot play YouTube videos) */
  fallbackUrl?: Maybe<Scalars['String']>;
  previewImgUrl: Scalars['String'];
  /** Url to YouTube video */
  url: Scalars['String'];
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  currency: Currency;
  value: Scalars['String'];
};

export type PageInfoV2 = {
  __typename?: 'PageInfoV2';
  number: Scalars['Long'];
  size: Scalars['Long'];
  totalElements: Scalars['Long'];
  totalPages: Scalars['Long'];
};

export type PageRequestV2 = {
  /** if null - default 0 */
  pageNumber?: InputMaybe<Scalars['Long']>;
  /** if null - default 100 */
  pageSize?: InputMaybe<Scalars['Long']>;
  /** if null or empty - default sort applied */
  sort?: InputMaybe<Array<SortFieldV2>>;
};

export type PagedResponseV2 = {
  pageInfo: PageInfoV2;
};

export type Query = {
  __typename?: 'Query';
  affiliate?: Maybe<Affiliate>;
  currentUser?: Maybe<CurrentUser>;
  dizraptor: Dizraptor;
  dizraptorCompliance?: Maybe<DizraptorCompliance>;
  dizraptorMobileRegistrationCollector?: Maybe<DizraptorMobileRegistrationCollector>;
};


export type QueryDizraptorArgs = {
  env: DizraptorEnvironment;
};

export enum SortDirectionV2 {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortFieldV2 = {
  /** if null - ASC */
  direction?: InputMaybe<SortDirectionV2>;
  fieldName: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['String'];
  kycLevel?: Maybe<DizraptorKycLevel>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  login: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export enum UserOtpType {
  OtpDisabled = 'OTP_DISABLED',
  OtpEmail = 'OTP_EMAIL',
  OtpGa = 'OTP_GA'
}
